import { Controller } from "@hotwired/stimulus";
import { Collapse } from "bootstrap";
import axios from "axios";
import dayjs from "dayjs";

function initDifficultyOptions(element) {
  const escapedDiscipline = $("#competition_discipline :selected")
    .val()
    .replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");

  const difficultyOptions = document.querySelector(
    `[data-select-discipline='selectOptions-${escapedDiscipline}']`
  );

  const selected = $(element).val();

  $(element).on("select2:clear", () => {
    $(this).parents(".nested-fields").find(".difficulty_value").val(null);
    $(this).parents(".nested-fields").find(".marking_sheet_value").val(null);
  });

  $(element).on("select2:select", evt => {
    const [difficulty, markingSheet = null] = evt.params.data.id.split("__");
    $(element)
      .closest(".nested-fields")
      .find(".difficulty_value")
      .val(difficulty);
    $(element)
      .closest(".nested-fields")
      .find(".marking_sheet_value")
      .val(markingSheet);
  });

  if (difficultyOptions) {
    $(element).html(difficultyOptions.cloneNode(true).children);
  }
  $(element).val(selected).trigger("change");
}

function initDifficulties(parentElem) {
  function setCollapse(el) {
    $(el)
      .find("input.class-nr")
      .on("input", e => {
        $(el).find("div.class-details span[data-nr]").text(e.target.value);
      });

    $(el)
      .find("input.class-name")
      .on("input", e => {
        $(el).find("div.class-details span[data-name]").text(e.target.value);
      });

    $(el)
      .find(".division-card")
      .on("click", () => {
        const body = $(el).find(".card-body")[0];
        Collapse.getOrCreateInstance(body).toggle();
        $(el).find("div.class-details i").toggleClass("fa-angle-down");
        $(el).find("div.class-details i").toggleClass("fa-angle-right");
      });
  }

  $(parentElem)
    .find(".difficulty_selection")
    .each(function () {
      if ($(this).hasClass("select2-hidden-accessible")) {
        $(this).select2("destroy");
      }
      initDifficultyOptions(this);
    });

  $(parentElem)
    .find(".select2")
    .each(function () {
      if (!$(this).hasClass("select2-hidden-accessible")) {
        window.initSelect2(this);
      }
    });

  if ($(parentElem).hasClass("nested-fields")) {
    setCollapse(parentElem);
  } else {
    $(parentElem)
      .find(".nested-fields")
      .each(function (i, el) {
        setCollapse(el);
      });
  }
}

function updateBasedOnDiscipline(parentElem) {
  const escapedDiscipline = $("#competition_discipline :selected")
    .val()
    .replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");

  $(".combined_diff").each(function () {
    $(this)[escapedDiscipline == "combined" ? "show" : "hide"]();
  });

  const eventcodes = $("#competition_eventcode").html();
  const additEventcodes = $("#competition_addit_eventcode").html();
  const types = $("#competition_competition_type").html();
  //const oldDifficulties = $(".old_difficulty_selection").html();

  const eventcodeOptions = $(eventcodes)
    .filter(`optgroup[label="${escapedDiscipline}"]`)
    .html();
  const additEventcodeOptions = $(additEventcodes)
    .filter(`optgroup[label="${escapedDiscipline}"]`)
    .html();
  const typeOptions = $(types)
    .filter(`optgroup[label="${escapedDiscipline}"]`)
    .html();

  if (eventcodeOptions) $("#competition_eventcode").html(eventcodeOptions);
  if (additEventcodeOptions)
    $("#competition_addit_eventcode").html(additEventcodeOptions);
  if (typeOptions) $("#competition_competition_type").html(typeOptions);
  initDifficulties(parentElem);
}

export default class extends Controller {
  static targets = ["competitionForm", "competitionEntryRuleTemplate"];

  competitionEntryRuleTemplateTargetConnected(element) {
    window.requestAnimationFrame(() => {
      window.initSelect2(element);
      const nestedField = $(element).closest(".nested-fields");

      $(element).on("select2:select", e => {
        axios({
          url: "/competition_entry_rule_details",
          method: "POST",
          data: {
            template_id: e.params.data.id
          },
          responseType: "json"
        }).then(({ data }) => {
          Object.entries(data).forEach(([k, v]) => {
            let el;
            switch (k) {
              case "disallow_single_license":
              case "requires_club":
                el = nestedField.find(`[data-input-target='${k}']`)[0];
                if (el) el.checked = true;
                break;
              case "horse_type":
              case "amateur_allowance":
                el = nestedField.find(`input[type=radio][value='${v}']`)[0];
                if (el) el.checked = true;
                break;

              case "athlete_results_from_date":
              case "athlete_results_until_date":
              case "horse_results_from_date":
              case "horse_results_until_date":
              case "athlete_exclusion_results_from_date":
              case "athlete_exclusion_results_until_date":
              case "horse_exclusion_results_from_date":
              case "horse_exclusion_results_until_date":
                {
                  nestedField.find(`[data-input-target='${k}']`).val(v);
                  nestedField
                    .find(`[data-input-target='${k}']`)
                    .prev()
                    .datepicker("update", dayjs(v).toDate());
                }
                break;
              default: {
                nestedField
                  .find(`[data-input-target='${k}']`)
                  .val(v)
                  .trigger("change");
              }
            }
          });
        });
      });
    });
  }

  competitionFormTargetConnected(element) {
    if (element.closest(".modal-dialog")) {
      element
        .closest(".modal-dialog")
        .classList.add("modal-dialog-competitions-form");
    }

    updateBasedOnDiscipline($("#division_rows"));

    $("#competition_discipline").on("change", function (evt) {
      updateBasedOnDiscipline($("#division_rows"));
      $("#competition_entry_rule_difficulty_rows .nested-fields").each(
        function () {
          updateBasedOnDiscipline(this);
        }
      );
      $("#competition_entry_rule_rows .nested-fields").each(function () {
        updateBasedOnDiscipline(this);
      });
    });

    $("#division_rows").on("cocoon:after-insert", function (e, inserted) {
      initDifficulties(inserted);
    });

    $(
      "#competition_entry_rule_rows,#competition_entry_rule_difficulty_rows"
    ).on("cocoon:before-remove", (e, inserted) => {
      if (!$(inserted).hasClass("entry-rule-existing")) {
        return;
      }
      e.preventDefault();
      this.deleteEntryRuleForm(inserted[0]);
    });

    $(
      "#competition_entry_rule_rows,#competition_entry_rule_difficulty_rows"
    ).on("cocoon:after-insert", function (e, inserted) {
      window.requestAnimationFrame(() => {
        window.initDatepicker();

        inserted.find(".nested-fields").each(function () {
          initDifficulties(this);
        });
      });
    });

    document.querySelectorAll(".nested-fields .card-body").forEach(el => {
      if (!el.classList.contains("show")) new Collapse(el).show();
    });
  }

  competitionFormTargetDisconnected() {
    if (document.querySelector("#modal .modal-dialog")) {
      document
        .querySelector("#modal .modal-dialog")
        .classList.remove("modal-dialog-competitions-form");
    }
  }

  restoreEntryRuleForm({ target }) {
    const nested = target.closest(".nested-fields");

    $(nested).find(".entry-rules-form").toggleClass("d-none");
    $(nested).find(".entry-rules-form-to-be-deleted").toggleClass("d-none");
    $(nested).find(".entry-rules-form-restore").toggleClass("d-none");
    $(nested).find(".entry-rules-form-delete").toggleClass("d-none");
    $(nested)
      .find(".entry-rules-form-title")
      .toggleClass("text-decoration-line-through");

    $(nested).find(".entry-rules-form-expand").toggleClass("d-none");
    $(nested)
      .find(".entry-rules-form-actions")
      .find("[name$='[_destroy]']")
      .val("0");
  }

  deleteEntryRuleForm(nested) {
    $(nested).find(".entry-rules-form").toggleClass("d-none");
    $(nested).find(".entry-rules-form-to-be-deleted").toggleClass("d-none");
    $(nested).find(".entry-rules-form-restore").toggleClass("d-none");
    $(nested).find(".entry-rules-form-delete").toggleClass("d-none");

    $(nested)
      .find(".entry-rules-form-title")
      .toggleClass("text-decoration-line-through");
    $(nested).find(".entry-rules-form-expand").toggleClass("d-none");
    //
    $(nested)
      .find(".entry-rules-form-actions")
      .find("[name$='[_destroy]']")
      .val("1");
  }
}
